import { render, staticRenderFns } from "./hotKeyword.vue?vue&type=template&id=a913beb0&scoped=true"
import script from "./hotKeyword.vue?vue&type=script&lang=js"
export * from "./hotKeyword.vue?vue&type=script&lang=js"
import style0 from "./hotKeyword.vue?vue&type=style&index=0&id=a913beb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a913beb0",
  null
  
)

export default component.exports